import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['slug'];

  static values = {
    teamId: Number,
  };

  clearError() {
    this.slugTarget.removeAttribute('aria-invalid');
  }

  // The copy icon never hits the server, so this event has to be client-side. teamId is only
  // rendered for Mixpanel-whitelisted teams, matching the guard around every other JS event in
  // layouts/_mixpanel.html.erb — without it, dev and staging would report anonymous copies.
  trackCopy() {
    if (!this.teamIdValue) {
      return;
    }
    window.mixpanel?.track('Client Login Link Copied', { team_id: this.teamIdValue });
  }
}
